import React from "react";
import Register from "../Components/user/Register";

const RegisterPage = () => {
  return <Register />;
};

export default RegisterPage;
